<script>

import { Overlay } from '../../'

export default {
    name: 'VWAP',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Volume Weighted Average Price - Intraday indicator',
                preset: {
                    name: 'VWAP',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff9800'
                    }
                }
            }
        },
        use_for() { return ['VWAP'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Spline' },
                update: `
                    let typical = (high[0] + low[0] + close[0]) / 3
                    let weighted = ts(0)
                    let total = ts(0)
                    let previousTime = ohlcv[iter - 1] && ohlcv[iter - 1][0]
                    let sameDay = previousTime != null && Math.floor(t / 86400000) === Math.floor(previousTime / 86400000)
                    weighted[0] = (sameDay ? weighted[1] || 0 : 0) + typical * vol[0]
                    total[0] = (sameDay ? total[1] || 0 : 0) + vol[0]
                    return total[0] ? weighted[0] / total[0] : typical
                `
            }
        }
    }
}
</script>
